
/**
 * Sleep for `ms` milliseconds
 * @param ms time in `milliseconds`
 */
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export default null
